// Auto generated file, do not manually modify!
// com.hotpads.customeranalytics.api.web.external.portalanalytics.MarketAnalyticsWebApiHandler

import { getClient } from '../../client';
import { httpApiRequest } from '@zg-rentals/ts-client-http-client';

import type {
  AreaDisplayEncodedGeometryDto,
  CompetitorWithOfferDto,
  ConstructionDetailsDto,
  CustomerAnalyticsGetRecentInventoryRequestDto,
  CustomerAnalyticsGetSfRegionPerformanceRequestDto,
  CustomerAnalyticsGetTopNewConstructionsRequestDto,
  CustomerAnalyticsMarketHighlightsDto,
  CustomerAnalyticsMarketRentPriceRequestDto,
  CustomerAnalyticsMarketRentPriceResponseDto,
  CustomerAnalyticsZgSearchApiResponseDto,
  DeprecatedZillowRegionType,
  ListingAlias,
  ListingCompsResponseDto,
  ListingQualityIssuesDto,
  MarketPackageDistributionResponseDto,
  MfRegionPerformanceResponseDto,
  MonthlyPriceHistoryByListingAliasResponseDto,
  TopConstructionDto,
} from '../..';

interface GetAreaDisplayGeometryParams {
  areaId?: number;
  zillowRegionId?: number;
}
interface GetCompsForListingParams {
  listingAlias?: ListingAlias;
  radius?: number;
  zrnNumber: string;
}
interface GetConstructionDetailsParams {
  address: string;
}
interface GetMarketHighlightsParams {
  zillowRegionId: number;
}
interface GetMarketPackageDistributionParams {
  includePackagesOnly?: boolean;
  zillowRegionId: number;
}
interface GetMfRegionPerformanceParams {
  zillowRegionId: number;
}
interface GetNewInventoryParams {
  limit: number;
  numberOfDays: number;
  offset: number;
  zillowRegionId: number;
  zillowRegionType: DeprecatedZillowRegionType;
}
interface GetNewInventoryInRadiusParams {
  latitude: number;
  longitude: number;
  radiusMiles: number;
}
interface GetTopNewConstructionsParams {
  zillowRegionId: number;
  zillowRegionType: DeprecatedZillowRegionType;
}

export const MarketAnalyticsWebApiHandler_getAreaDisplayGeometry_Path =
  '/api/web/portfolioPerformancePaths/getAreaDisplayGeometry';

export const MarketAnalyticsWebApiHandler_getAreaDisplayGeometry = (
  getParams: GetAreaDisplayGeometryParams,
  client = getClient(),
) => {
  return httpApiRequest<GetAreaDisplayGeometryParams, never, AreaDisplayEncodedGeometryDto>(
    {
      getParams: getParams,
      endpoint: MarketAnalyticsWebApiHandler_getAreaDisplayGeometry_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const MarketAnalyticsWebApiHandler_getCompetitorsWithSpecialOffer_Path =
  '/api/web/portfolioPerformancePaths/getCompetitorsWithSpecialOffer';

export const MarketAnalyticsWebApiHandler_getCompetitorsWithSpecialOffer = (
  postData: Array<string>,
  client = getClient(),
) => {
  return httpApiRequest<never, Array<string>, Array<CompetitorWithOfferDto>>(
    {
      endpoint: MarketAnalyticsWebApiHandler_getCompetitorsWithSpecialOffer_Path,
      method: 'POST',
      contextPath: '/customer-analytics',
      postData: postData,
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const MarketAnalyticsWebApiHandler_getCompsForListing_Path =
  '/api/web/portfolioPerformancePaths/getCompsForListing';

export const MarketAnalyticsWebApiHandler_getCompsForListing = (
  getParams: GetCompsForListingParams,
  client = getClient(),
) => {
  return httpApiRequest<GetCompsForListingParams, never, ListingCompsResponseDto>(
    {
      getParams: getParams,
      endpoint: MarketAnalyticsWebApiHandler_getCompsForListing_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const MarketAnalyticsWebApiHandler_getConstructionDetails_Path =
  '/api/web/portfolioPerformancePaths/getConstructionDetails';

export const MarketAnalyticsWebApiHandler_getConstructionDetails = (
  getParams: GetConstructionDetailsParams,
  client = getClient(),
) => {
  return httpApiRequest<GetConstructionDetailsParams, never, ConstructionDetailsDto>(
    {
      getParams: getParams,
      endpoint: MarketAnalyticsWebApiHandler_getConstructionDetails_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const MarketAnalyticsWebApiHandler_getListingQualityScoreForAliases_Path =
  '/api/web/portfolioPerformancePaths/getListingQualityScoreForAliases';

export const MarketAnalyticsWebApiHandler_getListingQualityScoreForAliases = (
  postData: Array<ListingAlias>,
  client = getClient(),
) => {
  return httpApiRequest<never, Array<ListingAlias>, Record<ListingAlias, ListingQualityIssuesDto>>(
    {
      endpoint: MarketAnalyticsWebApiHandler_getListingQualityScoreForAliases_Path,
      method: 'POST',
      contextPath: '/customer-analytics',
      postData: postData,
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const MarketAnalyticsWebApiHandler_getMarketHighlights_Path =
  '/api/web/portfolioPerformancePaths/getMarketHighlights';

export const MarketAnalyticsWebApiHandler_getMarketHighlights = (
  getParams: GetMarketHighlightsParams,
  client = getClient(),
) => {
  return httpApiRequest<GetMarketHighlightsParams, never, CustomerAnalyticsMarketHighlightsDto>(
    {
      getParams: getParams,
      endpoint: MarketAnalyticsWebApiHandler_getMarketHighlights_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const MarketAnalyticsWebApiHandler_getMarketPackageDistribution_Path =
  '/api/web/portfolioPerformancePaths/getMarketPackageDistribution';

export const MarketAnalyticsWebApiHandler_getMarketPackageDistribution = (
  getParams: GetMarketPackageDistributionParams,
  client = getClient(),
) => {
  return httpApiRequest<GetMarketPackageDistributionParams, never, Array<MarketPackageDistributionResponseDto>>(
    {
      getParams: getParams,
      endpoint: MarketAnalyticsWebApiHandler_getMarketPackageDistribution_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const MarketAnalyticsWebApiHandler_getMfRegionPerformance_Path =
  '/api/web/portfolioPerformancePaths/getMfRegionPerformance';

export const MarketAnalyticsWebApiHandler_getMfRegionPerformance = (
  getParams: GetMfRegionPerformanceParams,
  client = getClient(),
) => {
  return httpApiRequest<GetMfRegionPerformanceParams, never, Array<MfRegionPerformanceResponseDto>>(
    {
      getParams: getParams,
      endpoint: MarketAnalyticsWebApiHandler_getMfRegionPerformance_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const MarketAnalyticsWebApiHandler_getMonthlyPriceHistoryForListings_Path =
  '/api/web/portfolioPerformancePaths/getMonthlyPriceHistoryForListings';

export const MarketAnalyticsWebApiHandler_getMonthlyPriceHistoryForListings = (
  postData: Array<ListingAlias>,
  client = getClient(),
) => {
  return httpApiRequest<never, Array<ListingAlias>, MonthlyPriceHistoryByListingAliasResponseDto>(
    {
      endpoint: MarketAnalyticsWebApiHandler_getMonthlyPriceHistoryForListings_Path,
      method: 'POST',
      contextPath: '/customer-analytics',
      postData: postData,
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const MarketAnalyticsWebApiHandler_getNewInventory_Path = '/api/web/portfolioPerformancePaths/getNewInventory';

export const MarketAnalyticsWebApiHandler_getNewInventory = (
  getParams: GetNewInventoryParams,
  client = getClient(),
) => {
  return httpApiRequest<GetNewInventoryParams, never, CustomerAnalyticsZgSearchApiResponseDto>(
    {
      getParams: getParams,
      endpoint: MarketAnalyticsWebApiHandler_getNewInventory_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const MarketAnalyticsWebApiHandler_getNewInventoryByMultiRegion_Path =
  '/api/web/portfolioPerformancePaths/getNewInventoryByMultiRegion';

export const MarketAnalyticsWebApiHandler_getNewInventoryByMultiRegion = (
  postData: CustomerAnalyticsGetRecentInventoryRequestDto,
  client = getClient(),
) => {
  return httpApiRequest<never, CustomerAnalyticsGetRecentInventoryRequestDto, CustomerAnalyticsZgSearchApiResponseDto>(
    {
      endpoint: MarketAnalyticsWebApiHandler_getNewInventoryByMultiRegion_Path,
      method: 'POST',
      contextPath: '/customer-analytics',
      postData: postData,
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const MarketAnalyticsWebApiHandler_getNewInventoryInRadius_Path =
  '/api/web/portfolioPerformancePaths/getNewInventoryInRadius';

export const MarketAnalyticsWebApiHandler_getNewInventoryInRadius = (
  getParams: GetNewInventoryInRadiusParams,
  client = getClient(),
) => {
  return httpApiRequest<GetNewInventoryInRadiusParams, never, Array<TopConstructionDto>>(
    {
      getParams: getParams,
      endpoint: MarketAnalyticsWebApiHandler_getNewInventoryInRadius_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const MarketAnalyticsWebApiHandler_getRentPriceAverageByBedroom_Path =
  '/api/web/portfolioPerformancePaths/getRentPriceAverageByBedroom';

export const MarketAnalyticsWebApiHandler_getRentPriceAverageByBedroom = (
  postData: CustomerAnalyticsMarketRentPriceRequestDto,
  client = getClient(),
) => {
  return httpApiRequest<
    never,
    CustomerAnalyticsMarketRentPriceRequestDto,
    Array<CustomerAnalyticsMarketRentPriceResponseDto>
  >(
    {
      endpoint: MarketAnalyticsWebApiHandler_getRentPriceAverageByBedroom_Path,
      method: 'POST',
      contextPath: '/customer-analytics',
      postData: postData,
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const MarketAnalyticsWebApiHandler_getSfRegionPerformance_Path =
  '/api/web/portfolioPerformancePaths/getSfRegionPerformance';

export const MarketAnalyticsWebApiHandler_getSfRegionPerformance = (
  postData: CustomerAnalyticsGetSfRegionPerformanceRequestDto,
  client = getClient(),
) => {
  return httpApiRequest<
    never,
    CustomerAnalyticsGetSfRegionPerformanceRequestDto,
    Array<MfRegionPerformanceResponseDto>
  >(
    {
      endpoint: MarketAnalyticsWebApiHandler_getSfRegionPerformance_Path,
      method: 'POST',
      contextPath: '/customer-analytics',
      postData: postData,
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const MarketAnalyticsWebApiHandler_getTopNewConstructions_Path =
  '/api/web/portfolioPerformancePaths/getTopNewConstructions';

export const MarketAnalyticsWebApiHandler_getTopNewConstructions = (
  getParams: GetTopNewConstructionsParams,
  client = getClient(),
) => {
  return httpApiRequest<GetTopNewConstructionsParams, never, Array<TopConstructionDto>>(
    {
      getParams: getParams,
      endpoint: MarketAnalyticsWebApiHandler_getTopNewConstructions_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const MarketAnalyticsWebApiHandler_getTopNewConstructionsByMultiRegion_Path =
  '/api/web/portfolioPerformancePaths/getTopNewConstructionsByMultiRegion';

export const MarketAnalyticsWebApiHandler_getTopNewConstructionsByMultiRegion = (
  postData: CustomerAnalyticsGetTopNewConstructionsRequestDto,
  client = getClient(),
) => {
  return httpApiRequest<never, CustomerAnalyticsGetTopNewConstructionsRequestDto, Array<TopConstructionDto>>(
    {
      endpoint: MarketAnalyticsWebApiHandler_getTopNewConstructionsByMultiRegion_Path,
      method: 'POST',
      contextPath: '/customer-analytics',
      postData: postData,
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const MarketAnalyticsWebApiHandler_getUpliftBrainPredictedLiftByRecommendation_Path =
  '/api/web/portfolioPerformancePaths/getUpliftBrainPredictedLiftByRecommendation';

export const MarketAnalyticsWebApiHandler_getUpliftBrainPredictedLiftByRecommendation = (client = getClient()) => {
  return httpApiRequest<never, never, Record<string, number>>(
    {
      endpoint: MarketAnalyticsWebApiHandler_getUpliftBrainPredictedLiftByRecommendation_Path,
      method: 'POST',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};
